import Vue from 'vue';
import axios from 'axios';
import JsonExcel from 'vue-json-excel';
import VueExcelXlsx from 'vue-excel-xlsx';
import App from './App';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { clearAuthStorage, isExpiredSessionError } from './utilities/authSession';
import './styles/main.scss';
import './filters/toPercentage';
import './filters/toPercentageExtended';
import './filters/date';

Vue.component('downloadExcel', JsonExcel);
Vue.use(VueExcelXlsx);
Vue.config.productionTip = false;
Vue.config.devtools = true;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  response => response,
  (error) => {
    const requestUrl = error && error.config ? error.config.url : '';
    const isLoginRequest = typeof requestUrl === 'string' && requestUrl.includes('/auth/login');

    if (!isLoginRequest && isExpiredSessionError(error)) {
      store.commit('auth/clearAuth');
      clearAuthStorage();

      const { currentRoute } = router;
      const redirectPath = currentRoute && currentRoute.fullPath ? currentRoute.fullPath : '/';

      if (!currentRoute || currentRoute.path !== '/login') {
        router.replace({
          path: '/login',
          query: redirectPath && redirectPath !== '/login'
            ? { redirect: redirectPath }
            : {},
        }).catch(() => {});
      }
    }

    return Promise.reject(error);
  },
);

async function bootstrap() {
  try {
    await store.dispatch('auth/checkAuth');
  } catch (error) {
    // No-op: app should still mount and redirect unauthenticated users to login.
  }

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount('#app');
}

bootstrap();
